import React from "react";
import {
  InlineTypeahead,
  InlineTypeaheadProps,
} from "~/components/inline-typeahead";
import { useGetProps } from "~/ProjectForm/EditProjectComponents";
import { ProjectRequestFolderType } from "~/project-requests/ProjectRequestForm/types";

const format = (item: ProjectRequestFolderType): React.ReactNode => item;

type FolderTypePickerProps = {
  name: string;
};

export const FolderTypePicker: React.FC<FolderTypePickerProps> = (props) => {
  const { error, onChange, onBlur, value, required, disabled } =
    useGetProps<ProjectRequestFolderType>(props);

  const getData = async () => {
    return Object.values(ProjectRequestFolderType);
  };

  const args = {
    ...props,
    value,
    disabled,
    onChange,
    onBlur,
    required,
    error: error ?? "",
    getData,
    format,
  } as InlineTypeaheadProps<ProjectRequestFolderType>;

  return <InlineTypeahead {...args} />;
};
